import { render, staticRenderFns } from "./ContentDetailGrid.vue?vue&type=template&id=ce050478&scoped=true&"
import script from "./ContentDetailGrid.vue?vue&type=script&lang=js&"
export * from "./ContentDetailGrid.vue?vue&type=script&lang=js&"
import style0 from "./ContentDetailGrid.vue?vue&type=style&index=0&id=ce050478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce050478",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce050478')) {
      api.createRecord('ce050478', component.options)
    } else {
      api.reload('ce050478', component.options)
    }
    module.hot.accept("./ContentDetailGrid.vue?vue&type=template&id=ce050478&scoped=true&", function () {
      api.rerender('ce050478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/deskinfo/statistics/stats-tab-view/grid/ContentDetailGrid.vue"
export default component.exports